import F_GS from './GS';
import F_Other from './Other';
import { useGlobal } from '@/utils/useGlobal';

export default function F({ callBuy, updateSolar }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_ROW = ['kr', 'au', 'za'].includes(locale);
    const IS_GS: boolean = IS_NA || IS_EU || IS_ROW;

    return <>{IS_GS ? <F_GS callBuy={callBuy} updateSolar={updateSolar} /> : <F_Other callBuy={callBuy} />}</>;
}
